export default "/_next/static/chunks/fonts/Source Sans Pro Black-46ac4a80d50e7812e6771ffe58d8f980.otf";